<template>
  <div>
    <section class="home-page">
      <Header />
      <h2 class="heading">{{$t('solveProblems')}}</h2>
      <div class="Banner-add">
          <ads-91 :unitIdentifier="BannerIdentifier" />
      </div>
      <ul>
        <li @click.prevent="handleRedirect('dost')">
          <div class="list-img">
            <img
              :src="require('../../assets/images/group.svg')"
              alt="card-images"
            />
          </div>
          <div class="content">
            <h3>{{$t('Makefriends')}}</h3>
            <p>{{$t('talkAboutRomantic')}}</p>
          </div>
        </li>
        

        <li  @click.prevent="handleRedirect('astro')">
          <span class="list-img">
            <img
              :src="require('../../assets/images/group3.svg')"
              alt="card-images"
            />
          </span>
          <div class="content">
            <h3>{{$t('Astrology')}}</h3>
            <p>{{$t('problems')}}</p>
          </div>
        </li>
          <!-- <ads-91 :unitIdentifier="LeadIdentifier" /> -->
      </ul>
    </section>
    <AstrologyModel v-if="ShowTab" @handlehide="handlehide"/>
  </div>
</template>
<script>
import Header from "../../components/common/Header";
import AstrologyModel from '../../components/model/AstrologyModel'
import Footer from "../../components/common/Footer";
import CallHistoryList from "../../components/CallHistoryList";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    AstrologyModel,
    CallHistoryList
  },

  data() {
    return {
      loading: false,
      ShowTab: false,
      userDetail: null,
      maxMinuteForcall: null,
      LeadIdentifier:	"f7cb71c6-d7cb-4b22-8437-5ef93d897cb1", 		 	
      BannerIdentifier: "fbdb4fe7-e4a8-41b1-8a58-f05c02e30b6f",
      // LeadIdentifier: '82db509b-702b-4173-b626-b0756e60e688',
      // BannerIdentifier: '0ff24bda-e6f0-42ef-8d83-ba1e4de50af4',
    };
  },
  computed: {},
  methods: {
    handleRedirect(value) {
      if(value === 'dost'){
        this.$router.push('/call-history')
      }else{
        this.ShowTab = true
      }
    },
    handlehide(){
      this.ShowTab = false
    },
      changeLocale(locale) {
      if (["tl", "ta"].includes(this.$cookie.get("lang"))) {
        document.querySelector("body").classList.add("activeMultiLang");
      }
      this.$i18n.locale =
        this.$cookie.get("lang") || document.URL.split("=")[1] || "hi";
    },
  },
  sockets: {},
  mounted() {
    this.$cookie.set('DisconnectingStatus', 'true')
    this.changeLocale();
  }
};
</script>
